class Header {
	constructor($el) {
		this.$el = $el;
		this.$hero = $('.hero');
		this.last = 0;
		this.hideAfter = 100;

		this.init();
	}

	init = () => {
		this.setScrolledThreshold();
		this.scrollHandler();

		$(window).on('load', this.setScrolledThreshold);
		$(window).on('scroll', this.scrollHandler);
		$(window).on('resize', this.setScrolledThreshold);
	};

	setScrolledThreshold = () => {
		this.scrolledThreshold = this.$hero.length ? this.$hero.outerHeight() : 500;

		this.scrollHandler();
	};

	scrollHandler = () => {
		const cur = $(window).scrollTop();
		const navigationOpen = $('body').hasClass('nav--open');

		if (navigationOpen || cur < this.hideAfter) {
			this.$el.removeClass('header--hidden');
		} else if (cur > this.last) {
			this.$el.addClass('header--hidden');
		} else {
			this.$el.removeClass('header--hidden');
		}

		if (cur > this.scrolledThreshold) {
			this.$el.addClass('header--scrolled');
		} else {
			this.$el.removeClass('header--scrolled');
		}

		this.last = cur;
	};
}

export default Header;
